import {FILL_IT, SEND_LATER} from 'types/successPage';

export const PRESCRIPTION_STATUS = {
    DEFAULT: '',
    EYE_EXAM: 'eyeExam',
    FILL: 'fill',
    FILL_SUCCESS: 'fillSuccess',
    MISSING_ITEM_PRESCRIPTION: 'missingItemPrescription',
    MIXED_ITEMS_SUCCESS: 'mixedItemsSuccess',
    SKIP: 'skip',
    UPLOAD: 'upload',
    UPLOAD_SUCCESS: 'uploadSuccess',
    VISIBLY: 'visibly',
    VISTA: 'vista',
};

export const VISTA_PLUS = 'Vista Plus';

export const CL_RX_METHOD = {
    DOCTOR: 'doctor',
    EYE_EXAM: 'eyeExam',
    EYE_EXAM_ELIGIBILITY: 'eligibilityEyeExam',
    EYE_EXAM_ELIGIBILITY_FAILED: 'eligibilityEyeExamFailed',
    LOGIN: 'login',
    MANUALLY_DOCTOR: 'manuallyDoctor',
    UPLOAD: 'upload',
};

export const IS_LUXURY_EXPERIENCE = 'isLuxuryExperience';

export const VISIBLY_PRICE = 16;

export const PRESCRIPTION_STATUS_LABELS: {[key: number | string]: string} = {
    [FILL_IT]: 'Fill Manually',
    [SEND_LATER]: 'No Prescription Uploaded',
};
